import styled from 'styled-components';

export const Container = styled.section`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding: 20px;
`;

export const GroupVerification = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
  }

  h4 {
    font-family: 'Bebas Neue', sans-serif;
    text-transform: uppercase;
  }
`;

export const Verification = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.grey.black};

  img {
    width: 100%;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    div {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 12px;
      color: ${({ theme }) => theme.colors.grey[500]};
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.colors.grey[500]};
    }
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px;
    border-radius: 36px;
    background-color: ${({ theme }) => theme.colors.outher.attencion};
    color: ${({ theme }) => theme.colors.grey.black};
    text-transform: uppercase;

    p {
      margin-bottom: -4px;
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.grey.white};
  border-radius: 16px;

  h1 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};
    display: flex;
    align-items: flex-end;

    p {
      position: relative;
      font-family: 'Bebas Neue', sans-serif;
      top: -12px;
      margin-left: 4px;
    }
  }

  .button {
    width: fit-content;
    display: flex;
    padding: 8px 16px;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 32px;
    border: 1px solid ${({ theme }) => theme.colors.grey.white};

    span {
      margin-bottom: -2px;
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const Model = styled.div`
  width: 100%;
  padding: 8px;
  gap: 12px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey.white};
  border-radius: 100px;

  img {
    border-radius: 100%;
    width: 60px;
    height: 60px;
    object-fit: cover;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: ${({ theme }) => theme.colors.grey.black};

    span {
      display: flex;
      align-items: center;
      gap: 4px;

      svg {
        margin-top: -4px;
      }
    }
  }

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }
`;

export const Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;

  > a {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${({ theme }) => theme.colors.grey.black};
    background-color: ${({ theme }) => theme.colors.grey.white};
    padding: 4px 12px;
    border-radius: 16px;

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }

  > div {
    width: 100%;
    max-width: 210px;
    height: 210px;
  }
`;
